import script from "./half-map-2.vue?vue&type=script&setup=true&lang=js"
export * from "./half-map-2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__